import React from 'react';
import "./src/styles/global.css"
import browserHydrateFunction from './src/utils/browser-hydrate-function';
import AppLayout from './src/components/AppLayout';

export const wrapPageElement = ({ element, props }) => {
  return <AppLayout {...props}>{element}</AppLayout>;
};

export const replaceHydrateFunction = browserHydrateFunction;
